export class SidePosition {
    side: number;
    position: number;
}